import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { BasicStores, BasicStoresDetailParams, BasicStoresListParams } from './basicStores.types';

export const getBasicStoresList = (client: AxiosInstance) => async (params?: BasicStoresListParams) => {
  return (
    await client.get<PaginatedApiResponse<BasicStores[]>>(API_ROUTES.GET_BASIC_STORE_LIST, {
      params: { ...params },
    })
  ).data;
};

export const getBasicStoresDetails = (client: AxiosInstance) => async (params?: BasicStoresDetailParams) => {
  return (await client.get<PaginatedApiResponse<BasicStores>>(API_ROUTES.GET_BASIC_STORE_DETAIL, { params })).data;
};

export const basicStoresListQueries = {
  all: () => ['basicStores'],
  list: (params?: BasicStoresListParams) =>
    queryFactoryOptions<PaginatedApiResponse<BasicStores[]>>({
      queryKey: [...basicStoresListQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getBasicStoresList(client)(params),
    }),
  detail: (params?: BasicStoresDetailParams) =>
    queryFactoryOptions<PaginatedApiResponse<BasicStores>>({
      queryKey: [...basicStoresListQueries.all(), 'detail', params],
      queryFn: (client: AxiosInstance) => () => getBasicStoresDetails(client)(params),
    }),
};
